import Controller from "./backupPlan.controller";
import template from "./backupPlan.html";

const backupPlan = {
  template,
  controller: Controller,
};

export default backupPlan;



// WEBPACK FOOTER //
// ./src/pages/backupPlan/backupPlan.component.js